module.exports = __webpack_public_path__ + "img/32_19.22039ca7.png";